export const AUTH_STATUS = {
    SUCCESS: 'SUCCESS',
    INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
    TOKEN_PARSING_ERROR: 'TOKEN_PARSING_ERROR',
    PERMISSION_ERROR: 'PERMISSION_ERROR',
};
